module.exports = __webpack_public_path__ + "static/media/w (17).cc5b01d8.jpg";